import React from 'react';
export default function Underline(props) {
  return /*#__PURE__*/React.createElement("u", props.dataAttributes, props.children);
}